import React from "react";
import "./eligibility-criteria.css";

export default function EligibilityCriteria() {
  return (
    <section className="eligibility-hero container-fluid py-5">
      <div className="container">
        <div className="row g-4 align-items-center eligibility-box">

          {/* LEFT SIDE */}
          <div className="col-lg-6 pe-lg-5">
             <h2 className="eligibility-title mb-4">
             Eligibility <span className="highlight">Criteria</span> 
            </h2>
            <p className="eligibility-tagline">
            To make your borrowing experience seamless, ensure you meet the eligibility criteria below. Doing so not only accelerates your loan approval but also unlocks exclusive interest rates tailored to your profile.
            </p>

            <div className="eligibility-points">

              <div className="point">
                <span className="bullet">🎯</span>
                <p><strong>Must be</strong> an Indian Citizen</p>
              </div>

              <div className="point">
                <span className="bullet">🎓</span>
                <p><strong>Age</strong> must be between 21–35 years</p>
              </div>

              <div className="point">
                <span className="bullet">🏫</span>
                <p><strong>Minimum Graduation</strong> from a recognized institution</p>
              </div>

              <div className="point">
                <span className="bullet">⚖️</span>
                <p><strong>No Major</strong> criminal background</p>
              </div>

            </div>
          </div>

          {/* RIGHT SIDE */}
          <div className="col-lg-6">
            <div className="eligibility-showcase">
              <div className="blob"></div>

              <img
                src="https://images.unsplash.com/photo-1521791136064-7986c2920216?auto=format&fit=crop&w=800&q=80"
                alt="Eligibility Visual"
                className="eligibility-img"
              />

              <span className="shape-tag">✅ Ready to Apply?</span>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
